module.exports = __webpack_public_path__ + "static/pinkunicorn2-90435220ff103e27e0ba6f11f72995a0.jpeg";